import React from "react";

const handleLabel = (label) => {
  if (label && label.length > 1) {
    return `${label.length} Files are choosen.`;
  } else if (label.length === 1) {
    return label[0];
  } else {
    return "Choose File...";
  }
};

const getFileExtension = (name) => {
  const index = name.lastIndexOf(".");
  return name.slice(index);
};

const FileInput = ({
  display,
  name,
  label,
  accept,
  onChange,
  handleRename,
  value,
  file,
}) => {
  return display ? (
    <div className="input-group">
      <div className="custom-file">
        <input
          className="custom-file-input search-query text_area"
          type="file"
          name={name}
          id={name}
          multiple
          accept={accept}
          onChange={onChange}
        />

        <label className="custom-file-label rounded" htmlFor={name}>
          {handleLabel(label)}
        </label>
      </div>
    </div>
  ) : (
    <div className="input-group mb-3">
      <input
        type="text"
        className="form-control left-rounded"
        placeholder={handleLabel(label)}
        aria-describedby="file"
        onChange={handleRename}
        value={value}
      />
      <div className="input-group-append">
        <span className="input-group-text right-rounded" id="file">
          {getFileExtension(file)}
        </span>
      </div>
    </div>
  );
};

export default FileInput;
